import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicDECircuits = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SOLVING DE IN MECHANICAL & ELECTRICAL CIRCUITS"
      videos={[]} // No videos as mentioned in the points
      takeaways={[
        { text: "There are no videos for this type of questions. Just remember the following mathematical model and initial conditions. Substitute the values given in the question in the mathematical model and solve the Differential Equation using method of undetermined coefficients or method of variable parameters or Cauchy-Euler's type." },
        {  image: "/mcwd.png"},
        {  image: "/mcd.png"},
        {  image: "/fmcwd.png"},
        {  image: "/fmcd.png"},
        {  image: "/ecwd.png"},
        {  image: "/ecd.png"},
        {  image: "/fecwd.png"},
        {  image: "/fecd.png"},
        
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicDECircuits;